import './Manual.css';
import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next';
import TopBar from "../../common/TopBar";

export default function Manual() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const topHeader = {
    title: t('manualPage.title'),
    leftIcon: "/images/totp/ui/left.png",
  }
  const handleGoToList = () => {
    navigate("/vtotp/otp-list");
  }

  return(
    <div className="page-wrapper">
      <TopBar topHeader={topHeader} onLeftClick={handleGoToList}/>
      <div className="page-content">
        <div className="manual-container">

          {/* Intro */}
          <div className="manual-intro">
            <h2>{t('manualPage.introTitle')}</h2>
            <p>{t('manualPage.introText')}</p>
          </div>

          {/* Step 1 */}
          <section className="manual-section">
            <div className="manual-step-header">
              <div className="manual-step-number">1</div>
              <h2>{t('manualPage.step1Title')}</h2>
            </div>
            <div className="manual-content">
              <p dangerouslySetInnerHTML={{ __html: t('manualPage.step1Text1') }}></p>
              <p dangerouslySetInnerHTML={{ __html: t('manualPage.step1Text2') }}></p>
            </div>
              <div className="manual-screenshot narrow">
                <img src={`${process.env.PUBLIC_URL}/images/totp/ui/manual/guide1-security-login.png`}/>
              </div>
          </section>

          <div className="manual-divider"></div>

          {/* Step 2 */}
          <section className="manual-section">
            <div className="manual-step-header">
              <div className="manual-step-number">2</div>
              <h2>{t('manualPage.step2Title')}</h2>
            </div>
            <div className="manual-content">
              <p dangerouslySetInnerHTML={{ __html: t('manualPage.step2Text1') }}></p>
              <p dangerouslySetInnerHTML={{ __html: t('manualPage.step2Text2') }}></p>
            </div>
              <div className="manual-screenshot">
                <img src={`${process.env.PUBLIC_URL}/images/totp/ui/manual/guide2-2stepauth.png`}/>
              </div>
          </section>

          <div className="manual-divider"></div>

          {/* Step 3 */}
          <section className="manual-section">
            <div className="manual-step-header">
              <div className="manual-step-number">3</div>
              <h2>{t('manualPage.step3Title')}</h2>
            </div>
            <div className="manual-content">
              <p dangerouslySetInnerHTML={{ __html: t('manualPage.step3Text1') }}></p>
              <p dangerouslySetInnerHTML={{ __html: t('manualPage.step3Text2') }}></p>
            </div>
            <div className="manual-screenshot">
              <img src={`${process.env.PUBLIC_URL}/images/totp/ui/manual/guide3-use-otpapp.png`}/>
            </div>
          </section>

          <div className="manual-divider"></div>

          {/* Step 4 */}
          <section className="manual-section">
            <div className="manual-step-header">
              <div className="manual-step-number">4</div>
              <h2>{t('manualPage.step4Title')}</h2>
            </div>
            <div className="manual-content">
              <p dangerouslySetInnerHTML={{ __html: t('manualPage.step4Text1') }}></p>
              <p>{t('manualPage.step4Text2')}</p>
              <p>{t('manualPage.step4Text3')}</p>
            </div>
              <div className="manual-screenshot narrow">
                <img src={`${process.env.PUBLIC_URL}/images/totp/ui/manual/guide4-scancode.png`}/>
              </div>
              <div className="manual-tip">
                <p>{t('manualPage.step4Tip')}</p>
              </div>
          </section>

          <div className="manual-divider"></div>

          {/* Step 5 */}
          <section className="manual-section">
            <div className="manual-step-header">
              <div className="manual-step-number">5</div>
              <h2>{t('manualPage.step5Title')}</h2>
            </div>
            <div className="manual-content">
              <p dangerouslySetInnerHTML={{ __html: t('manualPage.step5Text1') }}></p>
              <p dangerouslySetInnerHTML={{ __html: t('manualPage.step5Text2') }}></p>
            </div>
              <div className="manual-screenshot">
                <img src={`${process.env.PUBLIC_URL}/images/totp/ui/manual/guide99-otpcode.png`}/>
              </div>
          </section>

          <div className="manual-divider"></div>

          {/* Complete */}
          <section className="manual-section">
            <div className="manual-intro">
              <h2>{t('manualPage.completeTitle')}</h2>
              <p>{t('manualPage.completeText')}</p>
            </div>
          </section>

          <div className="manual-footer"></div>
        </div>
      </div>
    </div>
  )
}
